import { Component, ReactNode } from "react";

interface Props {
    children: ReactNode;
    fallback?: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error }
    }

    componentDidCatch(error: Error, errorInfo: any): void {
        // // 你同样可以将错误日志上报给服务器
        // console.log('组件错误:', error);
        // console.log('错误信息:', errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || <h3>组件渲染错误</h3>
        }
        return this.props.children
    }
}